import { match as country } from "../../src/params/country.js";
import { match as destination } from "../../src/params/destination.js";
import { match as origin } from "../../src/params/origin.js";
import { match as vaccination } from "../../src/params/vaccination.js";

export const matchers = { country, destination, origin, vaccination };